import React from 'react';

export default function JourneyProgress({ steps, currentStep }) {
  return (
    <div className="flex items-center justify-center mb-6 px-2 font-body text-text">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isDone = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;

        return (
          <React.Fragment key={step.id}>
            {/* Step Circle */}
            <div className="flex flex-col items-center gap-1.5 relative">
              <div
                className={`
                  w-8 h-8 rounded-full border-2 flex items-center justify-center transition-all duration-300 z-10
                  ${isDone ? 'bg-dark border-dark' : ''}
                  ${isActive ? 'bg-primary border-primary shadow-primary-glow' : 'bg-surface border-surface-border'}
                `}
              >
                {isDone ? (
                  <span className="text-white text-xs font-bold">✓</span>
                ) : isActive ? (
                  <div className="w-2 h-2 rounded-full bg-dark" />
                ) : (
                  <span className="text-text-muted text-[10px] font-bold">{stepNumber}</span>
                )}
              </div>
              
              {/* Label */}
              <span 
                className={`font-heading text-[9px] font-bold uppercase tracking-wider whitespace-nowrap 
                ${isDone || isActive ? 'text-text' : 'text-text-muted'}`}
              >
                {step.ico} {step.label}
              </span>
            </div>

            {/* Connecting Line (don't show after the last step) */}
            {index < steps.length - 1 && (
              <div 
                className={`h-[2px] w-10 -mt-5 transition-colors duration-300
                ${stepNumber < currentStep ? 'bg-dark' : 'bg-surface-border'}`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}